import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Home from '../components/Home.jsx'
import Login from './Login.jsx'
import { onLoginEvent } from '../config/firebase.js'

function App() {

  const [isUserLoggedIn, setUserLoggedIn] = useState(false);

  useEffect(() => {
    onLoginEvent(setUserLoggedIn);
  }, []);
  

  return (
    <Box sx={{ minHeight: '75vh' }}>
    {
      isUserLoggedIn ? <Home /> : <Login />
    }
    </Box>
  );
}

export default App;